import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const homePage = () => import(/* webpackChunkName: "homePage" */ './views/homePage/homePage.vue');
const home = () => import(/* webpackChunkName: "home" */ './views/home/home.vue');
const product = () => import(/* webpackChunkName: "product" */ './views/product/product.vue');
const aboutMn = () => import(/* webpackChunkName: "aboutMn" */ './views/aboutMn/aboutMn.vue');
const contactUs = () => import(/* webpackChunkName: "contactUs" */ './views/contactUs/contactUs.vue');
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: "/home",
        },
       
        {
            path: '/homePage',
            name: 'homePage',
            component: homePage,
            redirect: "/home",
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                    meta: {
                        showFooter: true
                    }
                },
                {
                    path: '/product',
                    name: 'product',
                    component: product,
                },
               
                {
                    path: '/aboutMn',
                    name: 'aboutMn',
                    component: aboutMn,
                },

                {
                    path: '/contactUs',
                    name: 'contactUs',
                    component: contactUs,
                    meta: {
                        showFooter: true
                    }
                },
            ]
        }
    ]
})
